<template>
  <div class="course" v-show="courseShow">
    <div class="box">
      <div class="top">
        <h4>{{courseObj.CourseName}}</h4>
        <img src="https://img2.233.com/wx/union/618/2021/pc/close-icon.png" @click="$emit('close')">
      </div>
      <div class="content">
        <div class="item">
          <div class="name">活动价：</div>
          <div class="price" v-if="courseObj.MinActivityPrice === courseObj.MaxActivityPrice">￥{{courseObj.MaxActivityPrice}}</div>
          <div class="price" v-else>￥{{courseObj.MinActivityPrice}}-{{courseObj.MaxActivityPrice}}</div>
        </div>
        <div class="item">
          <div class="name mg-t17">选择科目：</div>
          <div class="labels">
            <label v-for="item in course" :key="item.MyClassId" @click="selectCourse(item)"
              :class="item.HasInEcart === 1 ? 'selected' : selectItem.MyClassId === item.MyClassId ? 'on' : ''">
              {{item.MyClassCName}}
              <img src="https://img2.233.com/wx/union/618/2021/pc/selected-course.png" class="selected-course" v-if="item.HasInEcart === 1">
              <template v-else>
                <span/><img src="https://img2.233.com/wx/union/618/2021/pc/hook-icon.png" class="hook">
              </template>
            </label>
          </div>
        </div>
      </div>
      <div class="button"><span @click="buy">确定</span></div>
    </div>
  </div>
</template>

<script>
import { GetBzNumCourseList } from "../../../lib/request"
export default {
  name: "Course",
  props: {
    courseShow: {
      type: Boolean,
      default: false
    },
    courseObj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      course: [],
      selectItem: {}
    }
  },
  watch: {
    courseShow() {
      this.GetBzNumCourseList()
    }
  },
  methods: {
    GetBzNumCourseList() {
      this.course = []
      GetBzNumCourseList({ courseIds: this.courseObj.MyClassIdList.join("," ) }, (res) => {
        if (!res.ResultDescription) {
          this.course = res.Result
        }
      })
    },
    selectCourse(item) {
      if (this.selectItem.MyClassId === item.MyClassId) {
        this.selectItem = {}
      } else {
        this.selectItem = item
      }
    },
    buy() {
      if (Object.keys(this.selectItem).length === 0) {
        this.$emit("openTip", { type: 2, text: "请选择科目" })
        return
      }
      window.location.href = window.location.origin + "/shopping/?myclassid=" + this.selectItem.MyClassId
    }
  }
}
</script>

<style lang="scss" scoped>
.course{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .74);
  z-index: 12;
  .box{
    width: 600px;
    background: #FFFFFF;
    border-radius: 10px;
    margin: 100px auto 0;
    .top{
      height: 72px;
      border-bottom: 1px solid #eee;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 25px 0 34px;
      h4{
        font-size: 24px;
        color: #333;
        font-weight: 400;
      }
      img{
        cursor: pointer;
      }
    }
    .content{
      padding-bottom: 12px;
      .item{
        margin: 20px 0 0 35px;
        &:nth-child(2){
          margin-top: 3px;
        }
        &:nth-child(1) .name{
          line-height: 36px;
        }
        .name{
          color: #333;
          font-size: 18px;
          font-weight: 400;
          display: inline-block;
          vertical-align: top;
          line-height: 30px;
        }
        .price{
          color: #F73836;
          font-size: 34px;
          font-weight: 800;
          display: inline-block;
          line-height: 36px;
        }
        .mg-t17{
          margin-top: 17px;
        }
        .labels{
          display: inline-block;
          width: 450px;
          height: 414px;
          overflow-y: auto;
          label{
            display: inline-block;
            line-height: 30px;
            color: #666;
            padding: 0 20px 0 9px;
            font-size: 16px;
            font-weight: 400;
            border: 1px solid #A0A0A0;
            margin-top: 17px;
            cursor: pointer;
            position: relative;
            margin-right: 12px;
            .selected-course{
              position: absolute;
              top: -17px;
              right: -1px;
            }
            span{
              position: absolute;
              bottom: 0;
              right: 0;
              width: 0;
              height: 0;
              border-bottom: 32px solid #A0A0A0;
              border-left: 32px solid transparent;
              z-index: 2;
            }
            .hook{
              position: absolute;
              bottom: 5px;
              right: 2px;
              width: 13px;
              height: 12px;
              z-index: 3;
            }
          }
          .selected{
            padding-right: 9px;
            background: #F6513E;
            color: #fff;
            border-color: #F6513E;
            cursor: not-allowed;
          }
          .on{
            background: #F6513E;
            color: #fff;
            border-color: #F6513E;
            span{
              border-bottom: 32px solid #EB2C19;
            }
          }
        }
      }
    }
    .button{
      border-top: 1px solid #eee;
      padding: 28px 0 26px;
      text-align: center;
      span{
        display: inline-block;
        width: 248px;
        height: 60px;
        line-height: 60px;
        background: linear-gradient(-75deg, #E00F23, #FA5E53);
        box-shadow: 0px 2px 10px 0px rgba(200, 49, 58, 0.38);
        border-radius: 30px;
        text-align: center;
        font-size: 22px;
        color: #fff;
        font-weight: 800;
        cursor: pointer;
      }
    }
  }
}
@media screen and (max-width: 1440px){
  .course .box{
    margin: 40px auto 0;
    .content .item .labels{
      height: 282px;
    }
  }
}
</style>